export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-r from-primary-500 via-primary-400 to-accent-400 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-xl md:text-3xl text-background-50 mb-3">
                皮皮漫画APP · 随时随地追更
              </h2>
              <p className="text-sm md:text-base text-background-100/90 leading-relaxed max-w-lg">
                下载皮皮漫画APP，享受流畅的下拉式阅读体验。支持离线缓存、夜间模式、更新推送提醒，让追更不再错过任何一话。
              </p>
              <div className="flex flex-wrap items-center gap-3 mt-5 justify-center lg:justify-start">
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-primary-600 font-semibold text-sm rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-smartphone-line"></i>
                  iOS 下载
                </a>
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50/20 border border-background-50/40 text-background-50 font-semibold text-sm rounded-full hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line"></i>
                  Android 下载
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-50/20 flex items-center justify-center">
                <i className="ri-smartphone-line text-6xl md:text-7xl text-background-50/80"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}